import { DEFAULT_CASHBACK_CONFIG } from './rewardsConstants';
import { majorToMinor, formDateToUtc, endFormDateToUtc } from './rewardsFormatters';

const parseOptionalInt = val => {
  if (val === '' || val === null || val === undefined) {
    return null;
  }
  return parseInt(val, 10);
};

const parseOptionalFloat = val => {
  if (val === '' || val === null || val === undefined) {
    return null;
  }
  return parseFloat(val);
};

const buildRestriction = form => {
  const hasRestriction =
    form.paymentGate ||
    form.specialityKey ||
    form.cityKey ||
    form.areaKey ||
    form.providerKey ||
    form.eligibleRailFamilies ||
    (form.planKeys && form.planKeys.length > 0);

  if (!hasRestriction) {
    return null;
  }

  const normalizedPlanKeys =
    form.planKeys && form.planKeys.length > 0
      ? form.planKeys
          .map(k => (k === null || k === undefined ? '' : String(k).trim()))
          .filter(Boolean)
      : [];
  const planKeys = normalizedPlanKeys.length > 0 ? normalizedPlanKeys : null;

  return {
    PaymentGate: form.paymentGate || 'ANY',
    CountryKey: form.countryKey || null,
    SpecialityKey: form.specialityKey || null,
    CityKey: form.cityKey || null,
    AreaKey: form.areaKey || null,
    ProviderKey: form.providerKey || null,
    EligibleRailFamilies: form.eligibleRailFamilies || null,
    PlanKeys: planKeys
  };
};

const buildLocalizations = form =>
  (form.localizations || []).map(l => ({
    LanguageCode: l.languageCode,
    Title: (l.title || '').trim(),
    Description: (l.description || '').trim(),
    TermsText: (l.termsText || '').trim(),
    CongratulationText: (l.congratulationText || '').trim()
  }));

export default function formatRewardsPayload(form) {
  const productKey = (form.selectedProducts || [])
    .map(p => (typeof p === 'string' ? p : p.value || p.key || p.ProductKey))
    .filter(Boolean)
    .join(',');

  const budgetMinor = majorToMinor(form.budget);

  const payload = {
    Name: form.name.trim(),
    CampaignType: parseInt(form.campaignType, 10),
    StartDateUtc: formDateToUtc(form.startDate),
    EndDateUtc: endFormDateToUtc(form.endDate),
    ProductKey: productKey,
    CountryKey: form.countryKey,
    Share: parseOptionalInt(form.share) || 0,
    BudgetMinor: budgetMinor,
    FundingSource: parseOptionalInt(form.fundingSource) || 1,
    ProviderSettlementCode: form.providerSettlementCode || null,
    InitialStatus: parseOptionalInt(form.initialStatus) || 0,
    Voucher: {
      Value: parseFloat(form.voucherValue),
      ValueType: parseInt(form.valueType, 10),
      PercentageCap: parseOptionalFloat(form.percentageCap),
      MinReceiptValue: parseOptionalFloat(form.minReceiptValue),
      UsageLimit: parseOptionalInt(form.usageLimit),
      UsageLimitPerUser: parseOptionalInt(form.usageLimitPerUser)
    },
    CashbackConfig: {
      SettlementTrigger: form.settlementTrigger
        ? parseInt(form.settlementTrigger, 10)
        : DEFAULT_CASHBACK_CONFIG.settlementTrigger,
      RequireFulfillment:
        form.requireFulfillment !== undefined
          ? form.requireFulfillment
          : DEFAULT_CASHBACK_CONFIG.requireFulfillment,
      ReversalWindowHours:
        parseOptionalInt(form.reversalWindowHours) ||
        DEFAULT_CASHBACK_CONFIG.reversalWindowHours,
      CashSettlementDelayHours:
        parseOptionalInt(form.cashSettlementDelayHours) ||
        DEFAULT_CASHBACK_CONFIG.cashSettlementDelayHours,
      RequiresAcknowledgement:
        form.requiresAcknowledgement !== undefined
          ? form.requiresAcknowledgement
          : DEFAULT_CASHBACK_CONFIG.requiresAcknowledgement,
      SettlementStrategy:
        parseOptionalInt(form.settlementStrategy) ||
        DEFAULT_CASHBACK_CONFIG.settlementStrategy
    },
    Restriction: buildRestriction(form),
    Localizations: buildLocalizations(form)
  };

  return payload;
}
